/*************************************** */
var selectionListA = [];
var selectionListB = [];

function resetSeleccionList() {
  console.log("reseteando.....");
  selectionListA = [];
  selectionListB = [];
}
function addElementListA(elementoNuevo, selected) {
  if (selectionListA.indexOf(elementoNuevo) === -1) {
    // Si no existe, agregar el elemento al array
    selectionListA.push(elementoNuevo);
  } else {
    var index = selectionListA.indexOf(elementoNuevo);

    // Verificar si el elemento existe en el array
    if (index !== -1) {
      // Utilizar splice para eliminar el elemento
      selectionListA.splice(index, 1);
    }
  }
}
function addElementListB(elementoNuevo, selected) {
  if (selectionListB.indexOf(elementoNuevo) === -1) {
    // Si no existe, agregar el elemento al array
    selectionListB.push(elementoNuevo);
  } else {
    var index = selectionListB.indexOf(elementoNuevo);

    // Verificar si el elemento existe en el array
    if (index !== -1) {
      // Utilizar splice para eliminar el elemento
      selectionListB.splice(index, 1);
    }
  }
}
function eliminarNumero(array, numeroAEliminar) {
  return array.filter((numero) => numero !== numeroAEliminar);
}
function addElementListAChanges(elementoNuevo, selected) {
  selectionListA = eliminarNumero(selectionListA, elementoNuevo);

  if (selectionListA.indexOf(elementoNuevo) === -1) {
    // Si no existe, agregar el elemento al array
    for (i = 0; i < selected; i++) {
      selectionListA.push(elementoNuevo);
    }
  }
}
function addElementListBChanges(elementoNuevo, selected) {
  console.log("1. selectionListB:"); 
  console.log(selectionListB);
  selectionListB = eliminarNumero(selectionListB, elementoNuevo);
  console.log("2. selectionListB:"); 
  console.log(selectionListB);
  if (selectionListB.indexOf(elementoNuevo) === -1) {
    // Si no existe, agregar el elemento al array
    for (i = 0; i < selected; i++) {
      selectionListB.push(elementoNuevo);
    }
  }
  console.log("3. selectionListB:"); 
  console.log(selectionListB);
}

function detectLeftButton(event) {
  if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) {
    return false;
  } else if ("buttons" in event) {
    return event.buttons === 1;
  } else if ("which" in event) {
    return event.which === 1;
  } else {
    return event.button == 1 || event.type == "click";
  }
}
/********************************************* */
var t;
var timePress=0;
$(function () {
  $("body").on("click", ".appCollectionMyDetail .my-list-item ", function (e) {
    let elementoNuevo = jQuery(this).find(".number").text().trim();
    let selectionArrayItems = [];

    console.log("click...Elemento Nuevo1111:");
    console.log(elementoNuevo);
    //highlight
    let selected = jQuery(this).hasClass("highlight");
    if (jQuery(this).closest(".mylist").hasClass("listItemsA")) {
      addElementListA(elementoNuevo, selected);
      selectionArrayItems = selectionListA;
    } else {
      addElementListB(elementoNuevo, selected);
      selectionArrayItems = selectionListB;
    }

    let selectionStringItems = selectionArrayItems.join(",");
    jQuery(this)
      .closest(".mylist")
      .find("input.input-filter-list")
      .val(selectionStringItems)
      .trigger("keyup");
  });

  $(document).on(
    "contextmenu",
    "  .appCollectionMyDetailForChange .my-list-item ",
    function (e) {
      return false;
    }
  );

  $("body").on(
    "mousedown",
    " .appCollectionMyDetailForChange .my-list-item",
    function (e) {
      let elementoNuevo = jQuery(this).find(".number").text().trim();
      let selectionArrayItems = [];
  
      console.log("click...Elemento Nuevo1111:");
      console.log(elementoNuevo);
      //highlight
      let selected = jQuery(this).hasClass("highlight");
      let contador = jQuery(this).data("contador") ?? 0;

      if (detectLeftButton(e)) {
        contador = contador + 1;
      } else {
        contador = contador - 1;
      }
      jQuery(this).data("contador", contador);
      jQuery(this).find(".badge-center").remove();
      if (contador > 0) {
        jQuery(this).append(
          '<span class="badge-center position-absolute top-0 start-0 translate-middle badge rounded-pill bg-danger">' +
            +parseInt(contador) +
            "</span>"
        );
      }

      if (contador <= 0) { 
        jQuery(this).data("contador", 0);
        jQuery(this).removeClass("highlight");
        //jQuery(this).closest("label").removeClass("highlight");
      } else {
        jQuery(this).addClass("highlight");
        //jQuery(this).closest("label").addClass("highlight");
      }
      if (jQuery(this).closest(".mylist").hasClass("listItemsA")) {
        addElementListAChanges(elementoNuevo, contador);
        selectionArrayItems = selectionListA;
      } else {
        addElementListBChanges(elementoNuevo, contador);
        selectionArrayItems = selectionListB;
      }

      let selectionStringItems = selectionArrayItems.join(",");

       console.log("selectionStringItems:")
       console.log(selectionStringItems);
      jQuery(this)
        .closest(".mylist")
        .find("input.input-filter-list")
        .val(selectionStringItems)
        .trigger("keyup");
    }
  );

  jQuery("body").on(
    "touchstart",
    ".appCollectionMyDetailForChange  .checklist-element",
    function (e) {
      e.preventDefault(); 
      t = window.setInterval(
        function (obj) {
          timePress += 0.1;

          if (timePress >= 0.5) {
            // TAP HOLD
            itemElement.execMinus(obj);
             itemElement.updateListAfterClick(obj);
            //TAP HOD END
            window.clearInterval(t);
            timePress = 0;
          }
        },
        100,
        this
      );
    }
  );

  jQuery("body").on("touchend", function (event) {
    timePress = 0;
    window.clearInterval(t);
  });
});
